<template>
  <el-dialog 
    :visible.sync="dialogVisible" 
    append-to-body
    width="360px"
    :show-close="false"
    title="Password Change"
    custom-class="login-form-dialog">
    <template>
      <el-form ref="loginForm" :model="loginData">
        <el-form-item label="Account">
          <el-input 
            v-model="loginData.account" 
            placeholder="Please input account" 
            maxlength="50"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <el-form-item label="Old Password">
          <el-input 
            v-model="loginData.old_password" 
            placeholder="Please input old password" 
            type="password"
            maxlength="20"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <el-form-item prop="password" label="New Password">
          <el-input
            v-model="loginData.password"
            placeholder="Please input new password"
            type="password"
            maxlength="20"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <el-form-item prop="password_rep" label="Repetition Password">
          <el-input
            v-model="loginData.password_rep"
            placeholder="Please repetition input new password"
            type="password"
            maxlength="20"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <div class="btn-wrap">
          <el-button type="primary" style="width: 100%;" @click="doSubmit" class="login-btn">Submit Change</el-button>
        </div>
      </el-form>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import confirm from '@/mixins/confirm'

export default {
  mixins: [confirm],
  data() {
    return {
      dialogVisible: false,
      loginData: {
        account: '',
        old_password: '',
        password: '',
        password_rep: '',
      },
      loginType: 0,
    }
  },
  methods: {
    ...mapActions({
      actionUserPasswordNoLogin: 'userPasswordNoLogin',
    }),
    async show(data) {
      this.loginData.account = data.account
      this.loginData.old_password = data.password
      this.dialogVisible = true
    },
    async doSubmit() {
      try {
        const { account, old_password, password, password_rep } = this.loginData;
        if (!account) {
          throw new Error('Pleace input account');
        }
        if (!old_password || !password || !password_rep) {
          throw new Error('Pleace complete form');
        }
        if (password != password_rep) {
          throw new Error('Password repetition is different');
        }
        this.confirmDialog('Confirm submit?', `Do you want to change your password?`, async () => {
          this.loading = true
          const ret = await this.actionUserPasswordNoLogin({
            account,
            old_password,
            new_password: password,
          })
          this.loading = false
          if (ret.code === 0) {
            this.$message.success('Save successful');
            setTimeout(() => {
              this.dialogVisible = false
            }, 600);
          }
        })
      } catch (e) {
        this.$message.warning(e.message);
      }
    }
  }
}
</script>
<style lang="less">
.login-form-dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
<style lang="less" scoped>
.logo-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    width: 64px;
  }
}
.login-type-wrap {
  padding: 32px 0 64px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
}
.btn-wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .back-link {
    margin: 16px auto 0;
  }
}
  .login-btn {
    background: @themeColor1;
    border: none;
    border-radius: 40px;
    margin: 0;
    &:active {
      opacity: .8;
    }
    &:hover {
      opacity: .9;
    }
  }
</style>
